module.exports = __webpack_public_path__ + "static/media/triplist.d5e2b0bd.svg";